export const creditDividerSx = { mx: 1.25 } as const;

export const chartCardSx = { height: '100%' } as const;

export const chartCardContentSx = {
  display: 'flex',
  flexDirection: 'column',
  pb: 1,
  '&:last-child': { pb: 1 },
} as const;

export const chartCardHeaderSx = { mb: 1, mx: 2, minHeight: 28 } as const;
